export type MarketplacePartnerRegisterPageFormV3Values = {
  accountType: string
  annualRevenue: string
  categories: string[]
  countryCode: string
  description: string
  email: string
  fcSolution: string
  firstName: string
  interestedInRetailMedia: boolean
  keyBrand: string
  lastName: string
  marketReadiness: string
  name: string
  phoneNumber: string
  revenueExpected: string
  targetCountries: string[]
  vatNumber: string
  website: string
}

export const marketplacePartnerRegisterPageFormV3DefaultValues: MarketplacePartnerRegisterPageFormV3Values =
  {
    accountType: '',
    annualRevenue: '',
    categories: [],
    countryCode: '',
    description: '',
    email: '',
    fcSolution: '',
    firstName: '',
    interestedInRetailMedia: false,
    keyBrand: '',
    lastName: '',
    marketReadiness: '',
    name: '',
    phoneNumber: '',
    revenueExpected: '',
    targetCountries: [],
    vatNumber: '',
    website: '',
  }
